import axios from "@/plugins/axios";
import * as insights from "./insights";


export const pansim = {
    ...insights,
}